import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import Icon from '@/components/Icon';
import useTranslation from '@/hooks/useTranslation';

const createStyles = (colors) => StyleSheet.create({
  header: {
    height: 53,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 10,
    backgroundColor: colors.solid_color_block,
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  caretIcon: {
    // 
  },
  spacer: {
    width: 44,
  },
});

function ContextualSidebarHeader({ title, onClose, onBack }) {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);

  const renderTitle = () => {
    if (!Array.isArray(title)) {
      return (
        <Text size='l' weight='medium' color='primary'>
          {title}
        </Text>
      );
    }

    return (
      <View style={styles.titleContainer}>
        {title.map((item, index) => (
          <React.Fragment key={index}>
            <Text size='l' weight='medium' color='primary'>
              {item}
            </Text>
            {index < title.length - 1 && (
              <Icon 
                name="angle-right" 
                size={10} 
                color={colors.text_color_primary}
                style={styles.caretIcon}
                solid
              />
            )}
          </React.Fragment>
        ))}
      </View>
    );
  };

  return (
    <View style={styles.header}>
      {onBack ? (
        <NavigationBarButton
          icon="angle-left"
          title={t('sidebar.back')}
          onPress={onBack}
        />
      ) : (
        <View style={styles.spacer} />
      )}
      {renderTitle()}
      <NavigationBarButton
        icon="close"
          title={t('sidebar.close')}
          onPress={onClose}
      />
    </View>
  );
}

export default ContextualSidebarHeader;